// HubOverview — KPI tile row at the top of each hub. Console-themed.
// Fetched via admin_get_hub_overview(p_hub_id). Rendered inside a hub's ConsoleShell.
import React, { useState, useEffect } from 'react';
import { KPI, useConsoleTheme } from './Console';
import { supabase } from '../supabaseClient';

export default function HubOverview({ hubId }) {
  const { t } = useConsoleTheme();
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hubId) { setLoading(false); return; }
    let cancelled = false;
    setLoading(true);
    supabase.rpc('admin_get_hub_overview', { p_hub_id: hubId }).then(({ data, error }) => {
      if (cancelled) return;
      if (error || !data) { setLoading(false); return; }
      setMetrics(data.metrics || []);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, [hubId]);

  if (loading) return <div style={{ marginBottom:14, fontSize:'1rem', color:t.mut }}>Loading hub overview…</div>;
  if (!metrics || metrics.length === 0) return null;

  return (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:10, marginBottom:6 }}>
      {metrics.map((m, i) => (
        <KPI key={i} label={m.label}
          value={typeof m.value === 'number' ? m.value.toLocaleString() : (m.value ?? '…')}
          sub={m.sub || ''} accent={m.accent || '#314F5C'} />
      ))}
    </div>
  );
}
